import React from "react";
import {
  TextField,
  InputAdornment,
  Box,
  CircularProgress,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

/**
 * Standalone search input that maintains focus
 * Completely isolated from DataGrid re-rendering
 */
const StandaloneSearchInput = ({
  value = "",
  onChange,
  placeholder = "Search...",
  isSearching = false,
  disabled = false,
}) => {
  return (
    <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
      <TextField
        variant="outlined"
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          if (onChange) {
            onChange(e.target.value);
          }
        }}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: isSearching ? (
            <InputAdornment position="end">
              <CircularProgress size={16} />
            </InputAdornment>
          ) : null,
        }}
        sx={{
          minWidth: 300,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "rgba(0, 0, 0, 0.23)",
            },
            "&:hover fieldset": {
              borderColor: "rgba(0, 0, 0, 0.87)",
            },
            "&.Mui-focused fieldset": {
              borderColor: "primary.main",
            },
          },
        }}
        // Prevent any form submission or enter key issues
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        // Additional props to maintain stability
        autoComplete="off"
        spellCheck={false}
      />
    </Box>
  );
};

StandaloneSearchInput.displayName = "StandaloneSearchInput";

export default StandaloneSearchInput;
